module.exports = __webpack_public_path__ + "static/TheMetSans-SemiboldItalic-7038b2693ea7652cce5a65e8233df008.woff";